import { Injectable } from '@angular/core';
import { IonicErrorHandler } from 'ionic-angular';

export interface ParsedError {
	message: string;
	status?: number;
	stack?: string;
  }

@Injectable()
export class GlobalErrorHandler extends IonicErrorHandler {

  constructor() {
    super();
  }

  handleError(error: any): void {
	super.handleError(error);
	// unroll errors from promises
	if (error.rejection) {
		error = error.rejection;
	}
	let parsedError = this.parse(error);
	if(window.Bridge && window.Bridge.coLog && window.Bridge.coLog.error)window.Bridge.coLog.error(`${parsedError.message} ${parsedError.status}`);
  }

  parse(error: any): ParsedError {

	// get best available error message
	let parsedError: ParsedError = {
		message: error.message ? error.message as string : error.toString()
	};

	// include HTTP status code
	if (error.status != null) {
		parsedError.status = error.status;
	}

	// include stack trace
	if (error.stack != null) {
		parsedError.stack = error.stack;
	}

	return parsedError;
  }
}


// WEBPACK FOOTER //
// ./src/util/error-handler.ts